import {
    CatalogApiObject,
    DossierOpenSearch,
    useFormaliteService,
    useFormulaireService,
} from '@europrocurement/l2d-domain';
import { useOffresCtx } from '@europrocurement/l2d-modules/providers/OffresProvider';
import { getPrestationsPayload } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider/functions';

const useAddFormality = () => {
    const { prestationFormaliteApi } = useFormaliteService();
    const { formulairesApi } = useFormulaireService();
    const { getOffres } = useOffresCtx();

    const addFormality = async (
        dossier: DossierOpenSearch,
        catalogs: CatalogApiObject[],
        resetStatus: boolean,
    ) => {
        const payloads = await getPrestationsPayload(catalogs, formulairesApi, resetStatus);

        const promises = payloads.map((payload) =>
            prestationFormaliteApi.apiPrestationsPost({
                prestationCreatePrestationDtoJsonldPrestationCreate: {
                    ...payload,
                    dossier: dossier.id as unknown as string,
                },
            }),
        );

        return await Promise.all(promises);
    };

    const isChangingCalculCategory = async (
        dossier: DossierOpenSearch,
        catalogs: CatalogApiObject[],
    ) => {
        if ((dossier?.siblingCount || 1) > 1) {
            return Promise.resolve(true);
        }

        const promises = catalogs.map((catalog) =>
            prestationFormaliteApi.apiPrestationsDossierIdCompatibleFormalityIdGet({
                dossierId: String(dossier.id),
                formalityId: String(catalog.package?.formalite?.id),
            }),
        );

        const responses = await Promise.all(promises);
        const allCombinable =
            responses.filter((response) => response.data.combinable).length === responses.length;

        if (allCombinable) {
            return Promise.resolve(true);
        }

        const offer = getOffres().find((o) => o.id === dossier.offreId);

        return Promise.resolve(offer?.calculCombine?.category === offer?.calculMultiple?.category);
    };

    return { addFormality, isChangingCalculCategory };
};

export default useAddFormality;
